// extracted by mini-css-extract-plugin
module.exports = {"message":"ExternalNurseryReferralDialog_message__3bMvU"};